export default {

    seleccionaNegocio:"Select business...",
    filtraPorEtiqueta:"Filter by tag",

    noEncontramosResultadosPara:"No results were found for ",
    mostrando:"Display",
    resultado:"result",
    resultados:"results",

    //ALMACÉN
    totalAlmacen:"Warehouse total",
    totalAlmacenDto:"Total warehouse discount",
    existenciasTeoricas:"Theoretical stocks",
    diferencia:"Discrepancy",
    noContabilizado:"Unaccounted",

    seleccioneUnaFechaDeInicioYUnaFechaDeFin:"Select stard date and end date",

    //INFORMES
    inicio: "Start",
    informes: "Reports",
    productos: "Products",
    ventasPorNegocio: "Sales by bussines",
    casas: "Houses",
    facturasSimplificadas: "Simplified invoices",
    comprasPorNegocio: "Purchases by business",
    comprasPorCasas: "Purchases by houses",
    gastosPorProveedor: "Expenses by Supplier",
    gastosPorSubproductos: "Expenses by raw materials",

    //CASAS
    nuevaCasa: "New house",
    casa: "House",
    negocio: "Business",
    desde: "From",
    hasta: "Until",
    consultar: "Check",
    infoCasas: "This consumption of houses comes from the expenses entered in the selected date range",
    exportarInforme: "Export report",
    exportarPdf: "Export as PDF",
    exportarExcel: "Export as Excel",
    exportarExcelSinSubproductos: "Export as Excel with raw materials",

    //TABLA
    fecha: "DATE",
    subproductos: "Raw materials",
    subproducto: "Raw material",
    unidades: "Units",
    partes: "Portions",
    precio: "Price",
    total: "Total",
    infoConsumo: "This consumption of houses comes from the expenses entered in the selected date range",
    noHay: "There is not",
    gastos: "Expenses",
    rangoDeFechas: "In this date range.",
    configuracion: "Configuration",
    datosFiscales: "Tax information",

    // DATOS FISCALES
    nombreFiscal: "Fiscal name",

    //FORM CASA
    nombreCasa: "Name of house",
    cifNif: "Identification number",
    direccion: "Address",
    provincia: "County",
    ciudad: "City",
    codigoPostal: "Zip code",
    pais: "Country",
    telefono: "Telephone",
    correoElectronico: "Email",
    baja: "Unsubscribe",
    guardar: "Save",
    cancelar: "Cancel",
    replicar: "Replay in other businesses",
    replicarCasa: "Replay house in other businesses",
    seleccionarTodos: "Select all",
    aceptar: "Accept",
    casaMin: "Houses",

    //
    compras: "Purchases",
    agregarCasa: "Add house",
    email: "Email",
    acciones: "Actions",
    editar: "Edit",
    enEsteNegocio: "In this business.",

    //PLACEHOLDER
    introduzcaNombre: "Enter name",
    introduzcaCifNif: "Enter CIF / NIF",
    introduzcaDireccion: "Enter address",
    introduzcaProvincia: "Enter county",
    introduzcaCiudad: "Enter city",
    introduzcaCodigoPostal: "Enter zip code",
    introduzcaTelefono: "Enter telephone",
    introduzcaCorreo: "Enter email",
    buscar: "Search...",

    //PROVEEDORES
    proveedores: "Suppliers",
    agregarProveedor: "Add supplier",
    proveedor: "Supplier",
    categoria: "Category",
    proveedoresMin: "Suplliers",

    //FORM
    nombreProveedor: "Name of supplier",
    acreedor: "Creditor",
    infoAcreedor: "(If a supplier is a creditor, it will not appear in Numier POS)",
    replicarProveedor: "Replicate supplier in other businesses",
    category: "Category",
    replicarCategory: "Replicate tag in other businesses",
    caracteresRestantes: "Characters remaining",

    //ETIQUETAS
    etiquetas: "Tags",
    etiqueta: "Tag",
    sinEtiqueta: "No tag",
    nuevaEtiqueta: "New tag",
    agregarEtiqueta: "Add tag",
    tipo: "Type",
    etiquetaPadre: "Base tag",
    tipoPadre: "Base type",

    //FORM
    nombreEtiqueta: "Name of tag",

    //SUBPRODUCTOS
    agregarSubproducto: "Add raw material",
    precioCompra: "Purchase price",
    escandallo: "Price tag",
    subproductosCreados: "Raw materials created",
    nuevaCategoria: "New category",
    materiaPrima: "Raw material",
    materiasPrimas: "raw materials",

    //FORM
    nuevoProveedor: "New supplier",
    nombreSubproducto: "Name of raw materials",
    codigoBarra: "Barcode",
    descripcion: "Description",
    tipoIva: "V.A.T. type",
    cuotaIVA: "V.A.T. fee",
    ivaIncluido: "(TAX included)",
    descuentoCompra: "Purchase discount",
    porcentaje: "(% Percentage)",
    guardarEnAlmacen: "Save in warehouse",
    stockMinimo: "Stock mínimium",
    stockOptimo: "Stock optimum",
    gastosPorProveedoresUnidos: "Expenses linked by supplier",

    //INFORME SUBPRODUCTO
    referencia: "Reference",
    uds: "Units",
    iva: "VAT",
    importe: "Amount",
    dto: "Discount",
    ttal: "Total",

    //PRODUCTOS
    producto: "Product",
    precioDeCoste: "Cost price",
    tarifa1: "Rate 1",
    tarifa2: "Rate 2",
    tarifa3: "Rate 3",
    tarifa4: "Rate 4",
    agregarProductos: "Add product",
    noHayProductosEnEsteNegocio: "There are no products in this business",
    sinCategoria: "Without Category",

    //FORM
    nombreProducto: "Name of product",
    codigoDeBarra: "Barcode",
    colorBoton: "Button color:",
    descuento: "Discount",
    precioCoste: "Cost price",
    opcionesAlSeleccionarElArticulo: "Options when selecting the product",
    numeroDeOpcionales: "Number of optional raw materials",
    impresoraComandasTPV: "TPV Order printer",
    impresoraComandasPDA: "PDA Order printer",
    copiaImpresoraComandasTPV: "TPV copy of order printer",
    copiaImpresoraComandasPDA: "PDA copy of order printer",
    impresionPlano1: "Level 1 printer",
    impresionPlano2: "Level 2 printer",
    impresionPlano3: "Level 3 printer",
    impresionKDSTPV: "Send order from TPV",
    impresionKDSPDA: "Send order from PDA",
    pedirPrecio: "Ask price",
    pedirPeso: "Ask weight",
    pedirImporte: "Ask amount",
    promocionable: "Promotable",
    mostrarPC: "Show on PC",
    mostrarPDA: "Show on PDA",
    noImprimir: "Do not print",
    numeroPlato: "Number of dishes by default",
    seleccionIngredientes: "Activate ingredient selection",
    introduzcaDescripcion: "Enter description",
    introduzcaCodigoDeBarras: "Enter barcode",
    introduzcaPrecioCoste: "Enter price code",
    opcion1: "Option 1",
    opcion2: "Option 2",
    opcion3: "Option 3",
    opcion4: "Option 4",
    opcion5: "Option 5",
    numOpcionales: "Number of optional raw materials",

    //OPERARARIOS
    operarios: "Operators",
    agregarOperario: "Add operator",
    apellido: "Last name",
    nombreOperarios: "Name of operator",
    pass: "Password",
    salario: "Salary",
    passTurn: "Password of shift",
    hombre: "Man",
    mujer: "Woman",
    replicarProducto: "Reply product in other business",
    introduzcaEscandallo: "Enter price tag",
    introduzcaStockMinimo: "Enter minimum stock",
    introduzcaStockOptimo: "Enter optimum stock",
    introduzcaPrecioCompra: "Enter purchase price",
    introduzcaApellido: "Enter last name",
    introduzcaPass: "Enter password",
    introduzcaEmail: "Enter email",
    introduzcaSalario: "Enter salary",
    introduzcapassTurn: "Enter password of shift",
    replicarOperario: "Reply operator in other business",
    TPV: "TPV",
    precioMed: "Average price",
    porUnidad: "Per units",
    porImporte: "Per amount",
    contrasenya: "PDA Password",
    repartidor: "Delivery man",
    noMostrarEnVentas: "No show in sales",
    noHayOperariosEnEsteNegocio: "There is no operator in this business",
    VerDetalles: "View Details",
    accesoDenegado: "Access Denied",

    //CLIENTES
    cliente: "Client",
    clientes: "Clients",
    companyia: "Campaign",
    agregarCliente: "Add Client",
    nombreCliente: "Name of client",
    saldo: "Balance",
    infoCliente: "in the case of using a balance card",
    tarifa: "Rate",
    descuentoImporte: "Amount discount",
    noHayClientesEnEsteNegocio: "There are no clients in this business",

    //IMPRESION
    impresionDeComandas: "Order printing",
    copiaDeImpresionDeComandas: "Copy of orders printing",
    impresionPorPlana: "Impression by level",
    monitorDeCocina: "Kitchen monitor",

    //INFORMES
    ventas: "Sales",
    tarjetas: "Cards",
    cheque: "Check",
    cambio: "Change",
    recuento: "Re-count",
    descuadre: "Imbalance",
    siguienteDia: "Next day",
    incidencias: "Incidents",
    recaudado: "Raised",
    noHayVentasEnEsteRangoDeFechas: "No sales in this date range",
    tickets: "Tickets",
    factura: "Invoices",
    noHayFormasDePagoEnEsteRangoDeFecha: "There are no payment methods in this date range",
    desglose: "Breakdown",
    sinBase: "No Base",
    base: "Base",
    impuesto: "Tax",
    facturasEmitidas: "Nominal invoices",
    mesa: "Table",
    cifnif: "CIF/NIF",
    cobro: "Payment",
    noHayFacturasEmitidasEnEsteRangoDeFecha: "There are no invoices issued in this date range",
    estadisticasAgencias: "Agency statistics",
    agencia: "Agency",
    comentario: "Comment.",
    noHayEstadisticasDeAgenciaEnEsteRangoDeFechas: "No agency statistics in this date range",
    desglosesImpuestos: "cash closing taxes",
    desglosesImpuestosAgencia: "Agency taxes",
    noHayFormasDePagoEnEsteRangoDeFechas: "There are no payment methods in this date range",
    cuentasAparcadas: "Accounts waiting",
    operacion: "Operation",
    operario: "Operator", //new
    noExisteDesgloseImpuestos: "No breakdown of taxes.", //new
    noHayCuentasAparcadasEnEsteRangoDeFechas: "No accounts parked in this date range",
    noHayCuentasAnuladasEnEsteRangoDeFechas: "There are no voided accounts in this date range",
    cierreCaja: "Cash closing",
    fechaCierre: "Closing date",
    venta: "Sales",
    totalRecaudado: "Total raised",
    noHayCierresDeCajaEnEsteRangoDeFecha: "There are no cash closings in this date range",
    cierreCajaZ: "Z Cash closing",

    //MODAL
    n: "Nº.",
    apertura: "Opening",
    cierre: "Closing",
    totalVenta: "Total sale",
    efectivo: "Cash",
    tarjetaCheques: "Check card",
    totalTeorico: "Theoretical Total",
    totalEnArqueo: "Total in tonnage",
    cambioSig: "Change to the next",
    volver: "Return",

    //OPERARIOS
    ventasPorOperarios: "Sales for operators",
    invitaciones: "Invitations",
    horas: "Hours",
    sueldo: "Salary",
    categorias: "Categoríes",

    //CLIENTES
    ventasPorClientes: "Sales per client",
    companya: "Company",
    consumiciones: "Consumptions",
    media: "Media",
    mediaSesion: "Half sessión",

    //AGENCIAS
    noHayAgenciasEnEsteMomento: "There are no agencies at the moment",
    agencias: "Agencies",
    nombreAgencia: "Agency name",
    comision: "Commission",
    replicarAgencias: "Reply agency",
    agregarAgencias: "Add agency",

    //MODIFICADORES
    nombreModificador: "Modifier name",
    grupos: "Groups",
    variacion: "Variation",
    resta: "Subtract",
    suma: "Addition",
    modificador: "Modifier",
    modificadores: "Modifiers",
    agregarModificador: "Add modifier",
    grupo: "Group",
    noHayModificadoresEnEsteNegocio: "There are no modifiers in this business",
    almacen: "Warehouse",
    todos: "All",
    precioCompraConIva: "Purchase price with VAT",
    precioCompraSinIva: "Purchase price without VAT",
    precioDescuentoSinIva: "Price with discount without VAT",
    codigoIdentificacion: "Identification code",
    replicarModificador: "Reply modifier",

    // SOPORTE ONLINE
    soporteOnline: "Online Support",
    soporteOnlineDetails: "Online Support - Details",
    abierto: "Open",
    esperandoRespuesta: "Waiting answer",
    respondido: "Answered",
    cerrado: "Close",
    tecnico: "Technical",
    comercial: "Commercial",
    facturacion: "Billing",
    noTicketsEnNegocio: "There are no tickets in this business",
    responderTicket: "Answer ticket",
    mensaje: "Message",
    cerrar: "Close",
    enviarTicket: "Send Ticket",
    nuevoTicket: "New ticket",
    asunto: "Subject",
    estado: "Status",
    departamento: "Department",
    visitas: "Visits",
    verTickets: "See ticket",
    tarjeta: "Card",

    //FORMAS DE PAGO
    nueva: "New",
    replicarFormaDePago: "Reply payment method",
    nombreFormaPago: "Name of payment method",
    formaDePago: "Payment method",
    formasDePago: "Payment methods",
    agregarFormaDePago: "Add payment methods",
    noHayFormasDePagoEnEsteNegocio: "There are no payment method in this business",
    nuevo: "New",

    //EDICIÓN MASIVA
    transferirProductosDeCategoria: "Transfer catgory",
    tranferir: "Transfer",
    impresionDeProductosDeCategorias: "Category products printing",
    impresoraComanda: "Order printer",
    impresoraComandaTpv: "TPV order printer",
    impresoraComandaPda: "PDA order printer",
    copiaImpresionDeComanda: "Copy order printer",
    copiaImpresoraComandasTpv: "Copy TPV order printer",
    copiaImpresoraComandasPda: "Copy PDA order printer",
    impresionPorPlano: "Printer by level",
    enviarComandaDesdeTpv: "Send order from TPV",
    enviarComandaDesdePda: "Send order from PDA",
    respetarOtrasImpresiones: "¿Respect other prints?",
    cambioDePrecioProductos: "Product price change",
    opcion: "Option",
    tipoDeTarifa: "Rate type",
    cambiarPrecio: "Change price",
    ajustes: "Settings",
    cambiarImpresionDeGrupo: "Change group of print",
    tranferirProductosDeUnaCategoriaAOtra: "Transfer products from one category to another",
    cambiarPreciosAProductos: "Change price to products",

    //WIDGETS
    consumoPorHoras: "Sale for hours",
    productosMasVendidos: "Top sellers product",
    ultimosTickets: "Last tickets",
    verTodos: "See all",
    arqueoDeCaja: "Cash audit",
    cobrado: "Charged",

    cajaCerrada: "Closed cash drawer",
    licenciaCaducada: "Expired License",
    cajonInteligente: "Smart cash drawer",
    moneda: "Coin",
    nivelReciclador: "Recycler Level",
    totalReciclador: "Recycler Total.",
    nivelCasete: "Casete Level",
    totalCasete: "Casete Level",
    totalMonedas: "Coins Total",
    totalBilletes: "Bills Total",
    totalEnDirectoPorNegocio: "Direct salesfor bussines",
    enCuenta: "On account",
    cajaOnline: "Online Cash driver",
    planoDeMesas: "Map of tables",
    planoDeTaquillas: "Map of lockers",
    nombrePlano: "Name of map",
    mesas: "Tables",
    taquillas: "Lockers",
    ocupacion: "Occupancy",
    enPlano: "In Map",
    desgloseTicket: "Breakdown of tickets",
    precioMedio: "Average price",
    apuntado: "Written",
    anulado: "Canceled",
    aparcado: "Reserved",
    indicencias: "Incidents",
    filtrarOperario: "To filter operator",
    situacionActualDeLosNivelesDelCajonInteligente: "Current situation of the levels of the smart cash drawer",
    verDetallesDeNiveles: "See details of levels",
    noHayCajonInteligenteParaMostrar: "There is no smart cash drawer to show",
    consulteConSuDistribuidor: "Please contact with your dealer",
    comparativaVentasAnteriores: "Comparative previous sales",
    graficaDeConsumoRespectoAHistoricoDeSesiones: "Consumption graph with respect to session history",
    graficaDeConsumoAgrupadaPorTramosHorarios: "Consumption graph grouped by sections",
    situacionActualDeOcupacionDeMesas: "Current situation of table occupancy",
    situacionActualDeOcupacionDeTaquillas: "Current situation of lockers occupancy",
    verPlanoCompleto: "View full map",
    rankingDeLaSesionActual: "Ranking of the current session",
    ultimosMovimientosDeLaCajaPorOperario: "Last movements of the csh drawer by operator",
    estadoActualDeLaCaja: "Current situation of the cash drawer",
    turnosDeOperarios: "Operator shifts",
    relacionDeHorasTrabajadasYVentasRealizadasPorOperario: "List of hours worked and sales made by operator",
    horarioInicio: "Start time",
    horaFin: "End time",
    horasTrabajadas: "Hours worked",
    noHayTurnosDeOperarioParaMostrar: "No operator shifts to show",
    propuestaDePedido: "Order proposal",
    pedidoAProveedor: "Supplier order",
    atencionHayMovimientosDeAlmacenQueNoSeHanDescargadoEnElNegocio: "Warning,there are warehouse movements that have not been unloaded in this businessAtención",
    seleccionarNegocio: "Select business",
    seleccionarProveedor: "Select Supplier",
    generarPedidoEnBlanco: "Generate blank order",
    generarPedido: "Generate order",
    propuestaDePedidoA: "Order proposal to ",
    buscarMateriaPrimaEnElMismoProveedor: "Search raw material in the same supplier",
    precioIVAIncluido: "VAT prices incluided",
    ref: "Reference",
    nombre: "Name",
    existencias: "Stock",
    pedido: "Order",
    precioArticuloUnidad: "Item price/ unit",
    precioPedido: "Order price",
    sinIVA: "Without VAT",
    porcentajeIVA: "% VAT",
    precioIVA: "VAT price",
    porcentajeDto: "% Discount",
    totalIVA: "VAT Total",
    observaciones: "Observations",
    noHaySubproductosEnEsteNegocioParaRealizarElPedido: "There are no sub products in this business to do the order",
    recuerdeQueParaQueAparezcanLosSubproductosDebenDeEstarAsociadosAUnProveedorYConfiguradosElStockMinimoYStockOptimo: " Remember that for the sub products to appear they must be associated with a supplier and configured the minimum stock and optimal stock",
    guardarPedido: "Save Order",
    totalIVAInc: "Total VAT Included",
    pedidosAProveedor: "Supplier order",
    fechaInicio: "Start date",
    fechaFin: "End date",
    pedidosConvertidos: "Converted orders",
    nuevoPedido: "New order",
    enviarPedidos: "Send order",
    convertido: "Converted",
    convertirEnGasto: "Convert an expense",
    modificar: "Modify",
    eliminar: "Remove",
    descargarComoPDF: "Download as PDF",
    descargarComoPDFSinPrecios: "Download as PDF without prices",
    descargarComoExcel: "Download as Excel",
    descargarComoExcelSinPrecios: "Download as excel without prices",
    enviarPorCorreo: "Send by email",
    eliminarListaCorreo: "Delete mailing list",
    anyadirListaCorreo: "Add mailing list",
    noHayPedidosAEsteProveedorEnEsteRangoDeFecha: "There are no orders to this supplier in this date range",
    enviarPedido: " Send order",
    enviarPedidoA: "Send order to",
    formato: "Format",
    PDF: "PDF",
    excel: "Excel",
    conPrecios: "With prices",
    sinPrecios: "Without prices",
    convertirPedido: "Convert order",
    tipoDeDocumento: "Document type",
    albaran: "Delivery note",
    generarEntradaEnAlmacenAlVerificar: "Generate warehouse entry when verifying",
    gastosDeCasas: "Household expenses",
    gastosPorCasa: "Expenses by household",
    noHayGastosPorCasasEnEsteRangoDeFechas: "There are no expenses for houses in this date range",
    ventasDeCategorias: "Category sales",
    ventasCategoriaDe: "Sales of categories of",
    volverAGeneral: "Regenerate",
    ventasDeProductos: "Product sales",
    filtrarPorTPV: "Filter by TPV",
    filtrarTPV: "Filter TPV",
    turnosDe: "Shifts of ",
    horaInicio: "Start hour",
    enActivo: "Active",
    ventasDeProductosDe: "Product sale of  ",
    ventasOperarios: "Operator sales",
    costesDeProductos: "Product cost",
    totalImportesVentas: "Total Sales Amount",
    totalCoste: "Total cost",
    costes: "Costs",
    costeUd: "Unit Cost ",
    coste: "Cost",
    porcentajeCosto: "% Cost",
    varCostoMed: "Medium Cost Variation",
    listaDeInvitaciones: "Invitation List",
    valor: "Value",
    volverALaLista: "Back to the list",
    ventasDeProductosGlobal: "Global Product Sales",
    porUnidades: "Per units",
    gastosPorEtiquetas: "Tag expenses",
    desgloseDeGastos: "Breakdown expense",
    referencias: "References",
    concepto: "Concept",
    gastosDeProveedores: "Supplier expenses",
    sinProveedor: "Without supplier",
    sinCasas: "Wiyhout houses",
    cierreDeCaja: "Cash drawer closing",
    primerTicket: "First Ticket",
    ultimoTicket: "Last Ticket",
    cheques: "Checks",
    cambioSigDia: "Change next day",
    ventasPorAgencias: "Agency sales",
    ventasPorFormasDePago: "Sales by payment method",
    exportarComoHTML: "Export as HTML",
    pendiente: "Unpaid",
    gasto: "Expense",
    desgloseDeImpuestos: "Tax breakdown",
    desgloseDelTicket: "Ticket breakdown",
    cuentasAnuladas: "Voided accounts",
    buscarPorHoras: "Search by hours",
    graficas: "Graphics",
    mostrarVentasAcumuladasPorDia:"Show cumulative sales per day", 
    seleccionaUnTpv:"You must select a TPV to see its details",
    deshabilitarCheckboxVentasAcumuladasPorDia:"Disable the 'Show cumulative sales per day' checkbox to see details.",
    dias: "Days",
    semanas: "Weeks",
    meses: "Months",
    ventasPorComensales: "Sales by diners",
    numeroDeComensales: "Number of diners",
    precioMedioPorComensal: "Average price per diner",
    ventasPorRangosHorarios: "Sales by time ranges",
    ops: "Ops",
    comensales: "Diners",
    detalleDeOperaciones: "Operation details",
    operaciones: "Operations",
    operacionMedia: "Middle operation",
    detalleDeComensales: "Diners detail",
    comensalMedio: "Average diner",
    noHayVentasEnLosRangosDeFechasDefinidos: "No sales in defined date ranges",
    transferencia: "Transfer",
    domiciliacion: "Domiciliation",
    fechaGasto: "Expense date",
    generarEntradaDeAlmacenAlVerificar: "Generate warehouse entry when checking",
    listaDeMateriaPrima: "Raw material list",
    preciosIVAIncluido: "Prices with VAT included",
    precioSinIVA: "Price without VAT",
    precioIVAInc: "Price with VAT included",
    IVA: "VAT",
    totalBase: "Total base",
    totalDocumento: "Total document",
    seleccioneUnaCasa: "Select a house",
    anyadirNuevoSubproducto: "Add new sub product",
    gestionDeGastos: "Expense management",
    deCaja: "Of Cash drawer",
    fueraDeCaja: "Out of Cash drawer",
    contabilizado: "Accounted",
    si: "Yes",
    no: "Not",
    grafica: "Graph",
    lista: "List",
    avanzado: "Advanced",
    noHayVentasDeProductosEnEsteRangoDeFechas: "No product sales in this date range",
    historicoDeProductos: "Product history",
    volverA: "Return to",
    general: "General",
    historialAlmacen: "Warehouse history",
    listadoDeExistencia: "Stock list",
    listadoHastaStockOptimo: "Listado hasta stock óptimo",
    pedidoHastaStockOptimo: "Order up to optimal stock",
    listadoExistenciaBajoMinimo: "List of stock under minimum",
    exportarValoracion: "Export valuation",
    importeDto: "Discount amount",
    detalleDelSubproducto: "Detail of sub product",
    nombreNegocio: "Business name ",
    noHaySubproductosConElMismoNombreEnTusOtrosNegocios: "There are no sub products with the same name in your other businesses",
    detalleAlmacen: "Warehouse details",
    entrada: "Imputs",
    inventario: "Inventory",
    salida: "Outputs",
    valorDto: "Discount value",
    noHayDatosEnEsteMovimientoDeAlmacen: "There are no data in this warehouse movement",
    historial: "Record",
    noHayMovimientoEnEstaMateriaPrima: "There are no movements in this raw material",
    dia: "Day",
    historialDeAlmacen: "Warehouse record",
    inventarios: "Inventories",
    entradas: "Imputs",
    salidas: "Outputs",
    completado: "Completed",
    verificado: "Verified",
    descargado: "Discharged",
    diaActual: "Actual day",
    movimientos: "Movements",
    enEsteRangoDeFechas: "In this date range",
    rangosHorarios: "Schedule ranges",
    nuevoRangoHorario: "New schedule range",
    verUnInformeDeRangosHorarios: "View a time range report",
    noHayRangosHorariosEnEsteNegocio: "There are no schedule ranges in this business",
    nombreRangosHorarios: "Name of schedule ranges",
    vistaMosaico: "Mosaic view",
    vistaLista: "List view",
    ordenarProductos: "Order products",
    BAJA: "UNSUBSCRIBE",
    frontalDeVenta: "Front of sale",
    agregarGasto: "Add expense",
    entrAlmac: "Warehouse entry",
    contab: "Accounting",
    tranferencia: "Tranfer",
    verificar: "Verify",
    entradaAlmacen: "Warehouse entry",
    preciosIVAInluido: "Price with VAT included",
    estaEntradaNoContieneNingunSubproducto: "This entry does not contain any sub products",
    cajasOnline: "Online cash drawer",
    minimo: "Mínimum",
    optimo: "Optimum",
    posicionGlobal: "Global position",
    empresa: "Business",
    ventasSinIVA: "Sales without VAT",
    neto: "Net",
    fechaDeCumpleanyos: "Date of birthday",
    recargoEquivalencia: "Surcharge of equivalency",
    anyadirMateriaPrima: "Add raw material",
    partesT1: "Parts T1",
    partesT2: "Parts T2",
    partesT3: "Parts T3",
    partesT4: "Parts T4",
    costeDto: "Discount cost",
    agregarMateriasPrimas: "Add raw materials",
    frontalDeVentas: "Sales front",
    unidadesEnOtroNegocios: "Units in other businesses",
    historialMateriaPrima: "Raw material record",
    verDetalles: "View details",
    borrarRangoHorario: "Delete time range",
    detallesDeLaEntradaEnAlmacen: "Warehouse entry detail",
    desgloseHorasTrabajadas: "Breakdown of hours worked",
    verProductosVendidos: "View sold products",
    verTicketsDelProducto: "View tickets of products",
    verTicketsDeEsasInvitaciones: "View tickets of those invitations",
    verTicketsDeEsaAgencia: "View tickets of this agency",
    gastosPorMateriasPrimas: "Raw material expenses",
    alDarUnProductoDeBajaDesapareceEnElTPVParaSuVentaPeroSigueApareciendoEnLosInformesDeVenta: "When you unsubscribe a product, it disappears in the POS/TPV for sale, but the product continues to appear in sales reports",
    cuandoUnProductoEsDeTipoDescuentoSuPrecioSeDescuentaDelTotalDeLaCuenta: "When a product is of a discount type, the price of this product is discounted from the total account",
    alActivarEstaOpcionApareceLosIngredientesDelProductoParaSeleccionarlo: " When you activate this option, the ingredients of the product appear to select them",
    alActivarEstaOpcionPuedeSeleccionarElPrecioDelProductoAlMarcarlo: "If you activate this option you can select the price of the product by checking it",
    alActivarEstaOpcionPuedeSeleccionarElPesoDelProductoAlMarcarlo: "If you activate this option you can select the weight of the product by checking it",
    alActivarEstaOpcionPuedeSeleccionarElImporteDelProductoAlMarcarlo: "If you activate this option you can select the amount of the product by checking it",
    alActivarEstaOpcionElProductoNoApareceraEnNumierTPV: "When activating this option the product will not appear in Numier TPV",
    alActivarEstaOpcionElProductoNoApareceraEnLaPda: "When activating this option the product will not appear in Numier PDA",
    alActivarEstaOpcionElProductoNoSeImprimiraEnElPendienteDeCobroNiEnLaFacturaSimplificada: "If you activate this option, the product will not be printed on the payment receipt nor will it be printed on the simplified invoice",
    guardarMateriaPrima: "Save raw material",
    copiarMateriaPrima: "Copy raw material",
    seleccioneQueTipoDeMateriasPrimasQuiereCopiar: "Select what type of raw materials you want to copy",
    seleccioneAQueCategoriaQuiereCopiarLasMateriasPrimas: "Select to which categories you want to copy the raw materials",
    copiaMateriaPrima: "Copy raw material",
    notas: "Notes",
    pedidos: "Orders",
    atencionLaMediaSinContarLosDiasConVentas: "Warning: The average without counting the days with sales at € 0 is: ",
    verDesgloseDeImpuestos: "View breakdown of taxes",
    verDetallesDetTicket: "View details of ticket",
    facturasNominativas: "Nominal invoices",
    verDetallesDeGasto: "View spending details",
    desgloseDeGastosPorEtiquetasHijas: "Breakdown of expenses by level",
    procedencia: "Source",
    suLicenciaDeNumierOnlineEstaAPuntoDeCaducar: "Your Numier Online license is about to expire",
    cajasOnlineTickets: "Cash drawer Online Tickets",
    cajasOnlineDetalles: "Cash drawer Online Details",
    cajasOnlinePlano: "Cash drawer Map",
    cajasOnlineProductos: "Cash drawer Online Products",
    transferir: "Transfer",
    herramientas: "Tools",
    ver: "View",
    detallesDeLaentradaEnAlmacen: "Details of the entry in the warehouse",
    ups:"Ups",
    laFechaDeInicioNoPuedeSerPosteriorALaDeFin:"The start date cannot be later than the end date",
    seleccioneUnProveedor:"Select a supplier",
    detallesDelPedido:"Details of order",
    correoEnviadoCorrectamente:"Email sent correctly",
    atencion:"Warning",
    debeIntroducirUnEmailParaEnviarElPedido:"You must enter an email to send the order",
    detalles:"Details",
    gastoVerificadoCorrectamente:"Expense verified correctly",
    estasSeguroDeEliminarElPedido:"¿Are you sure to delete the order?",
    estaOperacionNoSePuedeDeshacer:"This operation cannot be undone",
    siEliminarPedido:"Yes, delete order",
    pedidoEliminadoCorrectamente:"Order removed successfully",
    laReferenciaEsObligatoria:"The reference is mandatory",
    seleccioneLosNegociosParaHacerelPedido:"Select businesses to order",
    noHayProveedoresEnEsteNegocio:"There are no suppliers in this business",
    cuentasRectificadas:"Rectified accounts",
    noHayCuentasRectificadasEnEsteRangoDeFechas: "There are no rectified accounts in this date range",
    exportarContabilidad: "Export accounting",
    exportar: "Export",

    //NUEVOS
    confirmacionImportacionHeader: "Confirm Import",
    confirmacionImportacionText: "Are you sure you want to import?",
    cancelar: "Cancel",
    confirmar: "Confirm",
    registros: "registry",
    headerError: "ERROR",
    bodyError: "PLease insert a file with less than a 1.000 registry",
    en: "In ",
    sage: "SAGE",	
    sageplancuentas: "Account Plan",
    sageclientes: "Clients",
    sageefectos: "Efectos",
    sageasientos: "Accounting Entry",
    listadoDeAlmacen: "Warehouse Listing",
    pedidosProveedor: "Order to supplier",
    gestionDePersonal: "Workers management",
    configuracionCarta: "Menu configuration",
    importacionExcels:"Excel importer",
    carta: "Digital menu",
    camaras: "Cameras",
    perfil: "Profile",
    cerrarSesion: "Close session",
    desarrolladoPorNexodoDigitalSL: "Developed by Nexodo Digital S.L.",
    totalValores: "Total Values",
    totalValoresDto: "Total Values Disc.",
    totalValoresRecuento: "Total Counts Value",
    ultimoInventario: "Last inventory",
    filtrarEntreInventarios: "Filter betwen inventories",
    ultInventario: "Last inventory",
    primerInventario: "Last inventory",
    marcaDosInventariosParaVerLosDetallesEntreEllos: "Mark betwen two inventories to view details",
    salir: "Leave",
    anadirMovimientoAlmacen: "Add warehouse movement",
    nuevoInventario: "New Inventory",
    tienesUnInventarioSinTerminarElDia: "You have an unfinished inventory",
    pulseElBotonRealizarInventarioPara: "Click on 'Make inventory'to",
    volverARealizarlo: "Do it again",
    siDeseas: "If yoy wish to",
    comenzarElInventarioDeNuevo: "Start inventory again",
    comaMarqueLaCasillaEliminarDatosDeInventarioActual: ", mark 'remove actual inventory data'",
    eliminarDatosDelInventarioActual: "Remove actual inventory data",
    realizarInventario: "Start inventory",
    accesoDenegado: "Access denied",
    soloPuedeComprobar2InventariosAlMismoTiempo: "You can check only 2 inventories at the same time",
    cargando: "Loading...",
    configuracionAlmacen: "Warehouse configuration",
    actualizada: "updated",
    correctamente: "correctly",
    noSeAdmitenCamposEnBlanco: "Blank fields not accepted",
    todas: "All",
    categoriaClientes: "Clients category",
    seleccionaCompania: "Select company",
    agregarCategoriaDeClientes: "Add client category",
    categoriaPadre: "Main Category",
    elCampoNombreFiscalEsObligatorio: "Company name is mandatory",
    elCampoCifNifEsObligatorio: "Comany Cif Nif is mandatory",
    datosActualizadosCorrectamente: "Data update succesful",
    elCampoNombreEsRequerido: "Name field is required",
    creada: "created",
    rangoHorario: "Time table ",
    soloPuedeCrearUnMaximoDeXRangosHorarios: "Only 8 time table range available to create",
    deAcuerdo: "Agree",
    rangoHorario: "Time table ",
    eliminado: "eliminated",
    deseaEliminarEsteRangoHorario: "Do you want to delete the time table",
    siBorrarRangoHorario: "Yes, delete time table",
    ordenarProductosAlfabeticamente: "Sort products alphabetically",
    ordenarMateriasPrimasAlfabeticamente: "Sort raw materials alphabetically",
    asignarImpresorasSeleccionadasEnBlanco: "Asign printers blank selected",
    aplicarCambios: "Aply changes",
    ordenarAlfabeticamenteProductos: "Sort products alphabetically",
    ordenar: "Sort",
    ordenarAlfabeticamenteSubproductos: "Sort sob-products alphabetically",
    seleccioneElTipo: "Select type",
    impresionDeProductosEfectuadaCorrectamente: "print products succesful",
    tienesQueSeleccionarUnaCategoria: "You have to select a category",
    ningunaSeleccionada: "Selection void",
    transferenciaDeProductosEfectuadaCorrectamente: 'Products transfer succesful',
    relleneLosCamposObligatorios: "Fill mandatory fields",
    vistaFrontalTpv: "POS front view",
    editarPrecios: "Edit prices",
    cancelarEdicion: "Edit cancel",
    guardarOrden: "Save sort",
    bajaConBrackets: "[NOT AVAILABLE]",
    seleccionaUnaCategoria:"Select a category...",
    cambiarImpresorasAProductos: "Change products printers",
    igualar: "Equal to",
    sumar: "Add",
    restar: "Subtract",
    multiplicar: "Multiply",
    todasLasTarifas: "All rates",
    productosEditadosCorrectamente: "Products edited correctly",
    ordenActualizadoCorrectamente: 'Sort correctly updated',
    componentesDeVenta: "Sales items",
    delNegocioAClientes: "from business to clients",
    clasificacionDe: "Sort for",
    productosPorFamilia: "products by family",
    elementosQue: "Items that",
    varianALosProductos: "the products vary",
    paraLaComanda: "Handheld order",
    componentesComprados: "Items bought",
    aProveedoresQueComponenProductos: "a proveedores que componen productos",
    empresas: "Companies",
    proveedorasDeMateriasPrimasYServicios: "Raw materials and/or Service suppliers",
    alNegocio: "to business",
    fabricantesDeMateriasPrimas: "Raw materials manufacturers",
    aProveedores: "to suppliers",
    categoriasQueClasifican: "SOrt categories",
    materiasPrimasYProveedores: "raw materials and suppliers",
    personalCon: "Workers with",
    acceso: "access",
    alSistema: "to system",
    baseDeDatosDe: "Data Base of",
    consumidores: "consummers",
    enElNegocio: "in the business",
    clasificacionDeLa: "sort of",
    deLasVentas: "from sales",
    metodosDeCobro: "payment method",
    enElFrontalDeVenta: "in the POS front view",
    intervaloDeHorasParaConsultarVentas: "Hours interval to consult sales",
    configurarAlmacén: "Warehouse configuration",
    relacionDeMateriasPrimasParaLaConfiguracionDelAlmacen: "Warehouse raw materials configuration",
    herramientasGenerales: "General Tools",
    edicionMasiva: "Gross editing",
    categoriasCarta: "menu categories",
    categoriaCarta: "menu category",
    orden: "Sort",
    editada: "edited",
    anadirCategoria: "Add category",
    esteNegocioNoTieneAccesoAEsteModulo: "Access denied to this area for this business",
    paraMasInformacionContacteConSu: "For more information contact your",
    distribuidor: "distributor",
    formasDePagoCarta: "Menu payment methods",
    formaDePagoCarta: "Menu payment method",
    informacionCarta: "Menu information",
    datosDelNegocio: "Business information",
    nombreMostrado: "Name to show",
    telefonoWhatsapp: "WhatsApp number",
    datosPedidos: "Delivery information",
    tiempoMedioDePreparacionRecogidaMin: "Estimated time to pickup (min)",
    tiempoMedioDePreparacionDomicilioMin: "Estimated time of arrival for your order (min)",
    gastosDeEnvio: "Delivery costs",
    pedidoMinimo: "minimum order",
    interfaz: "Interface",
    textoEntrega: "Text for delivery service",
    textoPresentacion: "Text for business presentation",
    textoFormasDePago: "Text fro payment methods",
    textoHorarios: "Text for schedule",
    datosGuardadosCorrectamente: "Data saved successfully",
    materiasPrimasCarta: "Menu raw materials",
    materiaPrimaCarta: "menu raw material",
    referenciaMateriasPrimasTpv: "POS raw material reference",
    nombreDeLaMateriaPrimaEnElTpv: "Raw material name in the POS",
    disponible: "Available",
    replicarMateriaPrima: "Reply raw material",
    replicarMateriasPrimas: "Reply raw materials",
    nombreTpv: "POS name",
    noDisponible: "Not available",
    replicarTodasLasMateriasPrimas: "Reply all raw materials",
    estasSeguroDeReplicarTodasLasMateriasPrimasALosNegociosSeleccionados: 'Are you sure to reply all raww materials to selected business?',
    estaAccionNoSePuedeDeshacer: 'This action can not be undone!',
    siReplicar: 'Yes, reply',
    productosCarta: 'Menu items',
    productoCarta: 'menu item',
    referenciaProductoTpv: 'POS item reference',
    nombreDelProductoEnElTpv: 'item name in the POS',
    seleccionaCategoria: "Select category",
    seleccionaTipo: "Select type",
    nIngredientesSinCosto: "No cost ingredients ",
    maximoExtras: "Extra items maximun",
    alergenos: "allergens",
    nombreTarifa1: "Name rate 1",
    precioTarifa1: "Price rate 1",
    nombreTarifa2: "Name rate 2",
    precioTarifa2: "Price rate 2",
    nombreTarifa3: "Name rate 3",
    precioTarifa3: "Price rate 3",
    nombreTarifa4: "Name rate 4",
    precioTarifa4: "Price rate 4",
    imagen: "Image",
    copiarMateriasPrimas: "Copy raw materials",
    basico: "Básico",
    buscarNombreDeLaMateriaPrima: "Search raw material",
    seleccionaTipoPunto: "Select type...",
    bases: "Bases",
    opcionales: "Opctionals",
    extras: "Extras",
    cereales: "Cereals",
    crustaceos: "crustaceans",
    huevos: "Eggs",
    pescado: "Fish",
    cacahuetes: "Nuts",
    soja: "Soja",
    leche: "Milk",
    frutosDeCascara: "Frutos de cáscara",
    apio: "Apio",
    mostaza: "Mustrad",
    granosDeSesamo: "sesame grains",
    dioxidoDeAzufre: "sulfur dioxide",
    altramuces: "lupins",
    moluscos: "mollusks",
    cartaASecas: "Menu",
    extra: "Extra",
    opcional: "Optional",
    estreProcesoBorraraLasMateriasPrimasActualesEnLasCategoriasSeleeccionadasDeLosTiposElegidos: 'This process will erase actual raw materials in selected categories from selected types',
    aceptarProceso: "Accept action",
    necesitasMarcarAlMenosUnTipoYUnaCategoria: "You need to check at least one type and one category",
    materiaPrimaCopiadaCorrectamente: "Raw material correctly copied",
    editado: "edited",
    agregada: "added",
    relacion: "Relation",
    noPuedeHaberDosMateriasPrimasConElMismoTipo: "Can not be two raw materials with the same type",
    estasSeguroDeBorrarLaMateriaPrima: "Are you sure you want to delete the raw material?",
    siDeseoBorrarlo: "Yes, i do wat to delet it",
    seleccionaUnaCarta: "Select a menu",
    replicarProductos: "Reply products",
    verCarta: "View menu",
    verPedido: "View order",
    verQR: "View QR",
    nombreEnTpv: "Name in POS",
    cartaYPedido: "Menu and delivery",
    replicarTodosLosProductos: "Reply all products",
    editarImagen: "Edit image",
    esteNegocioNoContieneNingunaCarta: "This business does not have menu",
    estasSeguroDeReplicarTodosLosProductosALosNegociosSeleccionados: 'Are you sure you want to reply all items to selected business?',
    sustanciasQue: "Substances that",
    componenALosProductos: "form a product",
    informacionAcercaDel: "Informaction about the",
    negocioMinuscula: "business",
    actualizarPedidos: "Update order",
    pendienteDeConfirmacion: "Pending confirmation",
    confirmados: "Confirmed",
    enPreparacion: "in preparation",
    finalizados: "Finished",
    recogida: "Pick up",
    domicilio: "Delivery",
    noHayPedidosPendientesDeConfirmacion: "No orders pending confirmation",
    noHayPedidosConfirmados: "No orders conofirmed",
    noHayPedidosEnPreparacion: "No orders in preparation",
    noHayPedidosTerminados: "No finished orders",
    siBorrarPedido: "Yes, delete order",
    estasSeguroDeSuspenderElServicioEnMesas: "Are you sure you want to suspend table orders service?",
    siSuspendeElServicioEnMesasNoEntraranMasPedidosEnMesaHastaActivarloDeNuevo: "If you suspend table orders, no orders will be procesed until resume service",
    siSuspenderElServicioEnMesa: "Yes, suspend table orders",
    estasSeguroDeActivarElServicioEnMesas: "Are you sure you want to suspend table orders?",
    siActivaElServicioDeMesasVolveranAEntrarPedidosDeMesa: "If you resume table service, table orders will be procesed again",
    siActivarElServicioEnMesa: "Yes, resume table service",
    estasSeguroDeSuspenderElServicio: "Are you sure you want to suspend service?",
    siSuspendeElServicioNoEntraranMasPedidosHastaActivarloDeNuevo: "If you suspend table service, no orders will be procesed until resume service",
    siSuspenderElServicio: "Yes, suspend service",
    estasSeguroDeActivarElServicio: "Are you sure you want to suspend service?",
    siActivaElServicioVolveranAEntrarPedidos: "If you resume service, orders will be procesed",
    siActivarElServicio: "Yes, activate service",
    pedidoAceptadoCorrectamente: "Order accepted correctly",
    pedidoEnPreparacion: "Order in preparation",
    pedidoFinalizado: "Order finished",
    pedidoArchivado: "order archived",
    servicioActualizadoCorrectamente: "Service updated correctly",
    estasSeguroDeEditarLaObservacion: "Are you sure you want to edit  the observation?",
    siEditarObservacion: "Yes, edit observation",
    mesasActivadas: "TABLES ACTIVATED⠀",
    mesasDesactivadas: "TABLES DEACTIVATED⠀",
    crearNuevoProveedor: "Create new supplier",
    crearMateriaPrima: "Create raw material",
    eliminarMateriaPrima: "Delete raw material",
    sinCasaAsignada: "No house asigned",
    buscarPorRefONombreDeLaMateriaPrima: "Search by reference number or raw material name",
    seleccioneEtiqueta: "Select label...",
    unidadesStockMinimo: "minimum stok units",
    partesStockMinimo: "minimum stock parts",
    anadirProveedor: "Add supplier",
    amarillo: "yellow",
    cajas: "Boxes",
    botellas: "Botles",
    barriles: "Barrels",
    palets: "Palets",
    bolsas: "Bags",
    litros: "Liters",
    rollos: "Rolls",
    visualizar: "Visualize",
    sinCasa: "No house",
    elProveedorEsObligatorio: "Supplier is mandatory",
    laFechaEsObligatoria: "Date is mandatory",
    hayUnaMateriaPrimaSinUnidades: "Raw material with no units",
    hayUnaMateriaPrimaSinPrecio: "Raw material with no price",
    guardandoGasto: "Saving expense...",
    actualizado: "updated",
    creado: "created",
    laLongitudDelNombreNoPuedeSerMayorDe: "Nome longitud can not be longer than ",
    relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar: "Fill all the fields marked with * before send",
    seleccionaProveedor: "Select supplier...",
    filtrarPorFecha: "Filter by date",
    convertirAlbaranes: "Transform supplier order",
    cancelarConversion: "Cancell transform",
    convertir: "Transform",
    convertirAlbaranEnFactura: "Transform supplier order onto invoice",
    refFactura: "invoice reference",
    albaranesDeLaFactura: "Invoice supplier orders",
    finalizada: "finishes",
    conversion: "Transform",
    error: "Error",
    estaSeguroDeVerificarEsteGasto: "Are you sure to verify this expense?",
    siVerficarGasto: "Yes, verify the expense",
    estasSeguroDeEliminarElGasto: "Are you sure to delete the expense?",
    siEliminarGasto: "Yes, delete the expense",
    contabilizadoCambiadoCorrectamente: "posted changed correctly",
    gastoEliminadoCorrectamente: "Expense deleted correctly",
    hacerInventario: "Make inventory",
    seleccionarTodas: "Select all",
    inventarioRealizadoCorrectamente: "Inventory made correctly",
    traspaso: "Transfer",
    negocioDeDestino: "Receiving business",
    referenciaNecesaria: "Reference necesary",
    elMovimientoDeAlmacenTieneQueTenerAsignadoUnProductoOProductos: "The inventory movement has to have assigned a item or items",
    realizado: "done",
    buscarSinPuntos: "Search",
    enviarInventario: "Send inventory",
    volverAlAlmacen: "Back to warehouse",
    inventarioCompletado: "Inventory completed",
    inventarioNoEncontrado: "Inventory not found",
    cargandoInventario: "Loading inventory",
    importacion: "Import",
    importar: "Import",
    tienesQueSeleccionarUnArchivoDeImportacion: "You have to select a file to import",
    importandoVentasDelNegocio: "Importing sales from the business...",
    nuevosProductos: "New items",
    seHanCreadoLosSiguientesProductos: "The next items have been created",
    importandoMovimientosDeAlmacen: "Importing warehouse movements...",
    importandoDatos: "Importing data...",
    tienesQueSeleccionarUnArchivoDeImportacion: "You have to select a file to import",
    seleccionaCasa: "Select a house...",
    desgloseDeVentasPorProductos: "Sales details per items",
    noTienesPermisoParaVisualizarEsteInforme: "You do not have permissin to view thie inform",
    historicoVentasPorCliente: "Historic sales per client",
    buscarPorNombreDelCliente: "Search by client name",
    importeSinDto: "Amount with no discount.",
    nTickets: "Nº Tickets",
    seleccioneUnClienteValido: "Select a valid client",
    seleccioneUnNegocioParaVerLosTickets: "Select a business to consult tickets",
    ventasDeCategoriasPorClientes: "Sales by category per clients",
    desgloseDeVentasDeLaCategoria: "Category sales detail",
    verImporteEnCategoriasHijas: "View amunt per sub categories",
    gestionDePedidos: "Orders management",
    cargandoGastos: "Loading expenses...",
    tiempoMedioCocina: "Average preparation time",
    nComandas: "Nº orders",
    eliminada: "deleted",
    tiempoMedio: "Average time",
    noHayComandasEnviadasAlKdsEnEsteRangoDeFechas: "No orders sent to kds in this date range",
    tiempoMedioProducto: "Average item time",
    nProductos: "Nº Products",
    informePersonalizado: "Personalized Inform",
    nombreDelDispositivo: "Device Name",
    dispositivo: "Device",
    registrosHorarios: "Time registry",
    marshallEjecutadoCorrectamente: "Marshall correctly executed",
    mes: "Month",
    seleccionaUnaSemana: "Select a week",
    seleccioneUnaFechaValida: "Select a valid date",
    noMayuscula: "NO",
    siMayuscula: "YES",
    editarObservacion: "Edit observation",
    anadirObservacion: "Add observation",
    editarHoraInicioYHoraFin: "Edit start time and end time",
    editarHorario: "Edit schedule",
    editarHorarioDeTurno: "Edit shift schedule",
    observacion: "Observation",
    turnosOperarios: "Workers shifts",
    compartirEnlaceTurnos: "Share shift link",
    enlaceGeneradoExito:"Link generated successfully",
    enlaceCopiadoAlPortapapeles:"Link copied to clipboard",
    enlaceExternoTurnosTitle: "External link for appointment consultation",
    enlaceExternoTurnosLabel: "Through this link you can check the workers shifts. It will expire after 24 hours.",
    errorComunicacionBackend: "Communication error with the server.",
    enlaceExternoTurnosCaducadoTitle: "The link has expired",
    enlaceExternoTurnosCaducadoLabel: "To check the workers shifts, contact the business administrator to generate a new link.",
    ventasDeProductosMinusculas: "Items sales",
    pedidosGuionPasarelaDePago: "Orders - Payment Gateway",
    numPedidos: "Orders Number",
    costoPorPedido: "Cost per order",
    totalComisiones: "Total Commission",
    totalSinComisiones: "Total without Commission",
    errorEnLaPeticion: "Error request",
    rentabilidad: "Profitability",
    buscarPorNombreDelRepartidor: "Search by delivery person's name",
    verDesgloseDeTarifas: "View rate details",
    ventasPorMeses: "Sales per month",
    ventasHoras: "Sales per hours",
    tarifasDelProducto: "Rates by item",
    cantidad: "Quantity",
    fechaDesde: "Date from",
    fechaHasta: "Date until",
    seleccionaProcedencia: "Select origin...",
    verDesgloseFacturas: "View invoices details",
    verDesgloseMateriasPrimas: "View subproducts details",
    seleccionaUnaEtiqueta: "Select a label",
    buscarPorNombreDeLaMateriaPrima: "Search by raw material name",
    ventasDeMateriasPrimas: "Sales per raw material",
    seleccionaTpv: "Select POS...",
    deVentas: "from sales",
    totalComision: "Total commission",
    totalSinComision: "Total without commission",
    desgloseFacturas: "Invoices detail",
    facturasDelProveedor: "Supplier's invoices",
    retiradas: "Withdrawls",
    buscarTicket: "Search Ticket...",
    baseMayusculas: "BASE",
    numServ: "Num. Serv.",
    ticketMed: "Avg. Ticket",
    necesitasElegirUnTpvParaPoderVerLosDetallesDeEste: "Need to select a POS in order to see its details",
    ventasMinusculas: "sales",
    totales: "Totals",
    noTienesNingunRangoDeFechaCreadoDeseasCrearUnRangoDeFecha: "No time tables created. Do you want to create one?",
    siCrearUnRangoHorario: "Yes, create a time table",
    detalleDe: "Detail for ",
    cierresDeCaja: "cash desk closing",
    ventasNegocioPorZonaHoraria: "Sales per business per time zone",
    porZonaHoraria: " per time zone",
    detalleDeVentasSegun:"Sales detais according to",
    comensalesMinuscula: " diners",
    desgloseDe: "Detail for ",
    ticketsCobrados: "charged tickets",
    segunTipoDeIVA: "per tax type",
    facturasEmitidas: "Invoices issued",
    aClientes: " to clients",
    desgloseDeVentasSegun: "Sales details according to ",
    formasDePagoMinusculas: "payment methods",
    agenciasMinusculas: "agencies",
    cuentasACredito: "credit accounts",
    sumatorioDe: "Sum of ",
    impuestos: "taxes",
    porFechas: " by dates",
    cuentasAnuladasMinusculas: "reversed accounts",
    delNegocio: " from the business",
    cuentasRectificadas: "rectified accounts",
    cuentasRectificadasMinusculas: "rectified accounts",
    retiradasMinusculas: "withdrawls",
    ventaDeProductosPorNegocio: "Sales per business",
    rankingDe: "Ranking of",
    costeDeProductos: "Cost of items",
    margenDeCostes: "cost margin",
    segunVentasPorRangoDeFecha: "according to sales betwen this date ranges",
    historicoDeProducto: "Items historic",
    rankingAgrupadoDe: "Rank grouped by",
    enTodosLosNegocios: "in all business",
    ventasDeCategoriasPorNegocio: "Sales per category per business",
    agrupacionDe: "Grouping of ",
    ventasDeCategoriasMinusculas: "sales of lowercase categories",
    deProductos: "of items",
    invitacionesMinusculas: "courtesy",
    ventasPorMateriasPrimas: "Sales by raw materials",
    ventasDeMateriasPrimasMinusculas:"sales of raw materials",
    comprasDeMateriasPrimas: "purchase of raw materials",
    porRangoDeFecha: "by date ranges",
    comprasAProveedores: "purchase to suppliers",
    comprasAUnProveedor: "purchase to a supplier",
    porRangoDeFechaEn: "by range of date in",
    todosLosNegocios: "all business",
    comprasAgrupadasPorEtiquetas: "purchases grouped by labels",
    comprasAFabricantes: "purchases to manufacturers",
    comprasAUnFabricante: "purchases to a manufacturer",
    ranking: "Ranking",
    detallesDe: "Details of",
    turnos: "shifts",
    ventasPorClientesPlural: "Sales per clients",
    deVentasPorClientes: "from sales by clients",
    consultaDeVentasPorCliente: "Sales per client query",
    historico: "Historic",
    deVentasPorClientes: "of sales per client",
    numierPedidos: "Numier Delivery",
    informeDePasarelaDePago: "Payment gateway inform",
    desgloseDiarioDeLosPagosATraves: "Daily detail per payment method",
    pasarelaDePagoStripe: "Payment gateway (Stripe)",
    clicParaMasInformacion: "Click for more information",
    cantidadMinusculas: "quantity",
    totalMinusculas: "total",
    tarjetaYCheques: "Cards and Checks",
    seleccionaOperario: "Select worker...",
    necesitasSeleccionarUnProveedorParaPoderHacerUnPedido: "You need to select a supplier to place an order",
    estePedidoNoEsValido: "This order is not valid",
    quieresRestablecerElPedido: "Want to restart your order?",
    siRestablecerPedido: "Yes, restart the order",
    datosPersonales: "Personal info",
    datosDeAcceso: "Access info",
    contrasenaAntigua: "Old Password",
    contrasenaNueva: "New Password",
    confirmarContrasena: "Confirm Password",
    quieresDarDeAltaUnUsuario: "Do you want to create a new user?",
    quieresDarDeBajaUnUsuario: "Do you want to retire a user?",
    licencias: "Licencing",
    fechaCaducidad: "Due date",
    ilimitado: "UNLIMITED",
    lasContrasenasNoCoinciden: "Password mismatch",
    seleccionaUsuario: "Select user...",
    usuario: "User",
    negocios: "Businesses",
    balance: "Balance",
    teHaParecidoUtilEsteArticulo: "Did you found this article useful?",
    graciasPorTuOpinion: "Thanks for your opinion",
    asignarTurno: "Assign shift",
    vacaciones: "Vacations",
    descargarPDF: "Download PDF",
    enviarHorario: "Send schedule",
    incidenciasEnElMes: "incidents",
    diasDeVacacionesEnElMes: "vacation days in the month",
    diasDeVacacionesEnElAno: "vacation days in the year",
    nuevoTurno: "New shift",
    clonarTurno: "Clone shift",
    nombreDelTurno: "Shift name",
    diasDeLaSemana: "Days of the week",
    editarTurno: "Edit shift",
    borrarTurno: "Delete shift",
    evento: "Event",
    nombreEvento: "Event name",
    hayUnaIncidenciaEnEsteTurno: "There is an incident in this shift",
    fechaInicioTurno: "Shift start date",
    fechaFinTurno: "Shift end date",
    numHorasTurno: "Shift hours",
    fechaInicioTrabajada: "Satrt date worked",
    fechaFinTrabajada: "End date worked",
    numHorasTrabajadas: "Worked hours",
    noIniciado: "Not initiated",
    noFinalizado: "Not eneded",
    fechaInicioVacaciones: "Vacations start date",
    fechaFinVacaciones: "Vacations end date",
    turnoHorario: "Shift schedule",
    nombreTurno: "Shift name",
    campoRequerido: "Field required",
    introduzcaLosDiasDeLaSemana: "Input days of the week",
    crearTurnoHorarioDeOperario: "Create worker shift",
    introduzcaLosOperarios: "Input workers",
    laboral: "Workin",
    vacacional: "Holiday",
    seleccionaTurno: "Select a shift...",
    seleccionaLosNegociosALosQueQuiereClonarElTurno: "Select the business you wish to clone the shift",
    seleccionaLaFechaEnLaQueDeseasCopiarLosHorarios: "Select the date you wish to copy the schedules",
    seleccioneUnaSemana:"Select a week",
    lunes: "Monday",
    martes: "Tuesday",
    miercoles: "Thursday",
    jueves: "Wednsday",
    viernes: "Friday",
    sabado: "Saturday",
    domingo: "Sunday",
    laFechaSeleccionadaNoEsValida: "The selected date is not valid",
    turnoClonadoCorrectamente: "Shift cloned correctly",
    correoEnviadoCorrectamente: "Mail sent correctly",
    estasSeguroDeBorrarElTurnoSeleccionado: "Are you sure you want to delete the selected shift?",
    siBorrarTurno: "Yes, delete shift",
    necesitasCrearAlgunTurnoParaPoderCrearCuadrantes: "You need to create a shift in order to create a worker schedules",
    estasSeguroDeEditarElTurno: "Are you sure to edit the shift?",
    siEditarTurno: "Yes, edit shift",
    hoy: "Today",
    turno: "Shift",
    turnoBorradoCorrectamente: "Shift deleted correctly",
    informacion: "Information",
    elDiaNoCorrespondeConLaConfiguracionDelTurnoElegido: "The day is not corresponding withn the shift selected",
    turnoCopiadoCorrectamente: "Shift copied correctly",
    turnoDeOperarioAgregadoCorrectamente: "Worker shift added correctly",
    turnoDeOperarioEliminadoCorrectamente: "Worker shift deleted correctly",
    turnoDeOperarioEditadoCorrectamente: "Worker shift edited correctlyTurno de operario editado correctamente",
    tecnicoConsultasTecnicasIncidencias: "Support (Technical advice, incidents...)",
    comercialActivacionDeProductosInformacionServicios: "Sales (Product activation,Information, Services...)",
    administracionFacturacionReclamaciones: "Administrative (Invoices, complaints...)",
    elAsuntoEsObligatorio: "Message subject is mandatory",
    elMensajeEsObligatorio: "Message is mandatory",
    soporteOnlineEnviadoCorrectamente: "Online Support sent correctly",
    todosLosNegociosMayusculas: "All businesses",
    recordarMisDatos: "Remember access info",
    paraCualquierIncidenciaOMasInformacionPuedePonerseEnContactoConNosotros: "For any incidents or information, please contact us",
    iniciarSesion: "Login",
    haOlvidadoSuContrasena: "Have you forgot your password?",
    haHabidoUnErrorAlConectarPruebeDeNuevo: "An error has occured connecting, please try again",
    elEmailNoPuedeEstarEnBlanco: "Email field can not be in blank",
    elEmailNoEsValido: "Email not valid",
    laContrasenaNoPuedeEstarEnBlanco: "Password can not be in blank",
    estaPaginaNoSeEncuentraEnElSistema: "This page is not in the system",
    volverAlInicio: "Back to start",
    obtenerContrasena: "Password request",
    disculpeLasMolestiasEstamosDeMantenimiento: "Sorry for the inconvinience, we are under maintenance",
    vuelvaAIntentarloMasTarde: "Try again later",
    acepto: "Accept",
    categoriasDeClientes: "Clients categories",
    categoriaDeCliente: "client category",
    nombreCategoria: "Category name",
    noSeleccionada: "Not selected",
    cobradoMayusculas: "CHARGED",
    envioProgramadoPara: "Delivery scheduled for",
    eliminarPedido: "Delete order",
    aceptarPedido: "Accept order",
    pedidoConfirmado: "Order confirmed",
    archivarPedido: "File order",
    detallesPedido: "Order details",
    nota: "Note",
    precioUd: "Price unit",
    gratis: "FREE",
    guardarYAceptarPedido: "Save and accept the order",
    seleccionaGrupo: "Select group...",
    todosMayusculas: "ALL",
    nombreOperario: "Worker name",
    apellidos: "Surname",
    claveAcceso: "Access code",
    codigoDeTurnos: "Shift code",
    claveAccesoPDA: "Handy access code",
    seleccionaIVA: "Select TAX",
    calcularCostoAPartirDeMateriasPrimas: "Calculate cost from raw materials",
    seleccionaImpresoraDeComandasTPV: "Select printer for orders from POS",
    seleccionaImpresoraDeComandasPDA: "Select printer for orders from Handy",
    buscarMateriaPrima: "Search raw material",
    nuevaMateriaPrima: "New raw material",
    ordenarSubproductos: "Order sub products",
    seleccionaEtiqueta: "Select label...",
    clonarProducto: "Clone item",
    clonarProductoCarta: "Clone item",
    buscarSinPuntos: "Search",
    noPuedeHaberDosMateriasPrimasConElMismoTipo: 'There can not be  two raw materials with the same type',
    sinProveedores: "With no suppliers",
    agregadas: "added",
    modificadas: "modified",
    materiaPrimaEliminadaCorrectamente: "Raw material deleted correctly",
    asociacion: "associated",
    materiaPrimaOrdenadaCorrectamente: "Raw material ordered correctly",
    productosCopiadosCorrectamente: "Items copied correctly",
    responder: "Answer",
    cliente: "Client",
    administracion: "Administrative",
    soporteTecnico: "Technical support",
    horaInicioMayusculas: "Star time",
    horaFinal: "End time",
    personaDeContacto: "Contact person",
    motivoVisita: "Visit issue",
    servicioBajoMantenimiento: "Service under maintenance",
    desplazamiento: "Displacement",
    ticketEnviadoCorrectamente: "Ticket sent correctly",
    precioCompraConDescuento: "Purchase price with discount",
    introduzcaLasPartesDelStockMinimo: "Input parts for minimmum stock",
    actualizarStockMinimoYOptimo: "Update minimmum and optimal stock",
    subproductoDeVerdad: "Sub product",
    entregado: "Delivered",
    retirada: "Withdrawal",
    subtotal: "Subtotal",
    pagosACuenta: "Payments on account",
    horaDeApertura: "Opening time",
    horaInicio: "Start time",

    condicionesDeNumierOnline: "Condiciones de Numier Online",
    descripcionDelServicio: "Descripcion del Servicio",
    terminosIntroduccionParte1: "El servicio en la nube de Numier ofrecido por NEXODO DIGITAL S.L. (apartir de ahora NEXODO), facilita a sus clientes el acceso online a la información actualizada de sus negocios.",
    terminosIntroduccionParte2: "Para ello, las aplicaciones de punto de venta de Numier enviarán a través de internet detalles de las ventas realizadas y otro tipo de información que pueda ser interesante para sus clientes.",
    terminosIntroduccionParte3: "El acceso a este servicio se realizará a través de la página web https://www.numier.com/clientes, donde podrá consultar la información enviada por sus puntos de venta.",
    terminosIntroduccionParte4: "NEXODO reserva el derecho de mejorar, modificar o anular el servicio en cualquier momento.",
    politicaDePrivacidad: "Política de privacidad",
    privacidadParte1: "1. NEXODO ha realizado la siguiente declaración de privacidad con el objetivo de manifestar su firme propósito de proteger su privacidad. NEXODO le ruega que lea atentamente esta política de privacidad antes de utilizar este servicio ya que ello implica que NEXODO recopile y procese sus datos personales de acuerdo a esta política. NEXODO se reserva el derecho a modificar en cualquier momento la política de privacidad. En ese caso NEXODO se compromete a ponerse en contacto con usted para informarle de las modificaciones que le afecten.",
    privacidadParte2: "2. NEXODO respeta sus opciones de privacidad. En el caso de que nos proporcione alguna información se tratará de acuerdo a esta política.",
    privacidadParte3: "3. NEXODO le recomienda discreción a la hora de proporcionar información a operadores o propietarios del sitio. Es importante que tenga en cuenta que proporcionar información personal en lugares de acceso público, como salas de chat implica que cualquier persona con acceso a internet pueda disponer de su información. Le recomendamos que no introduzca ninguna información que no desee que otros puedan ver en estas zonas públicas.",
    privacidadParte4: "4. Si decide registrarse en NUMIER ONLINE es posible que deba aportar datos personales. Es importante que registre correctamente la información en la fecha de registro. Si su información personal cambia tras haber efectuado el registro deberá cambiarla o actualizarla inmediatamente. De no hacerlo es posible que no reciba algún servicio o información de NEXODO.",
    privacidadParte5: "5. NEXODO puede utilizar su información personal con la finalidad de realizar mejoras en este sitio.",
    privacidadParte6: "6. NEXODO recopila estos datos con la finalidad de obtener información para mejorar sus servicios y sus productos. Y es posible que utilicemos la información que nos ha proporcionado para enviarle ofertas por correo electrónico o postal que puedan ser de su interés.",
    privacidadParte7: "7. Para anular su suscripción a dichos correos deberá ponerse en contacto con NEXODO para informar de su decisión. De otro modo NEXODO mantendrá la información del usuario hasta el momento en que la suscripción sea anulada o hasta el vencimiento de cualquier período necesario descrito en la normativa vigente.",
    privacidadParte8: "8. NEXODO no revelará sus datos a ningún tercero sin su consentimiento, a menos que pensemos de buena fe que la ley lo requiere.",
    privacidadParte9: "9. Tiene la posibilidad de anular la totalidad de los datos de su suscripción que figuren en nuestra base de datos. Para ello deberá ponerse en contacto con la empresa y realizar su solicitud.",
    privacidadParte10: "10. 10. NEXODO ha tomado medidas para garantizar que la información sólo estará disponible para el usuario que introdujo la información en un principio. ",
    privacidadParte11: "11. Sólo se puede acceder a la información una vez se haya introducido la contraseña.",
    privacidadParte12: "12. Este sitio puede contener enlaces a otros sitios que no están asociados con NEXODO. Estos sitios tienen sus propias políticas de privacidad de las que NEXODO no se hace responsable. El acceso a estos sitios vinculados se realiza bajo su exclusiva responsabilidad.",
    privacidadParte13: "13. NEXODO garantiza la seguridad de la información referente a sus usuarios exceptuando los casos que se describen a continuación:",
    privacidadParte13dos: "- Si NEXODO dispone de su consentimiento.",
    privacidadParte13tres: "- Si se insta a NEXODO a proporcionar dicha información por indicación legal, requerimiento judicial u otro procedimiento jurídico.",
    privacidadParte13cuatro: "- Si la revelación de estos datos es necesaria para proteger los derechos y la propiedad de NEXODO.",
    privacidadParte13cinco: "- Si la revelación de información de sus datos es necesaria para mejorar los servicios y productos de nuestros clientes, incluido usted.",
    privacidadParte14: "14. NEXODO garantiza el mantenimiento adecuado de su información en un servidor seguro y encriptado al que sólo puedan acceder terceros autorizados. ",

    cartaDigital: "Digital menu",
    horarios: "Schedules",
    zonas: "Zoness",
    modificarHorariosDeLaCarta: "Modify menu time table",
    modificarZonasDeLaCarta: "Modify menu zones",
    diaDeLaSemana: "Day of the week",
    esteNegocioNoTieneCarta: "This business does not have digital menu",
    tipoDeEnvio: "Delivery type",
    nuevoHorario: "New time table",
    elCampoDiaDeLaSemanaEsRequerido: "The day field is mandatory",
    borrarHorario: "Delete time table",
    laHoraInicioNoPuedeSerMayorQueLaHoraFin: "Start time can not be later than end time",
    noHayHorariosEnEsteNegocio: "No time table for this business",
    deseaEliminarEsteHorario: "Do you want to delete this time table?",
    siBorrarHorario: "Yes, delete time table",
    seleccioneDiaDeLaSemana: "Select day of the week",
    seleccioneTipoDeEnvio: "Select delivery type",

    //NUEVO
    importacionSage: "Sage import",
    ejercicio: "Fiscal year",
    codigoEmpresa: "Business code",
    asiento: "Accounting entry",
    cargoAbono: "Debit entry",
    codigoCuenta: "Account code",
    fechaAsiento: "Accounting entry date",
    comentario: "Comment",
    importeAsiento: "Accounting entry amount",
    numeroPeriodo: "Period number",
    delegacion: "Businnes delegation",
    canal: "Channel",
    ejercicioFactura: "Accounting entry invoice",
    serie: "Serie",
    factura: "Invoice",
    suFacturaNo: "Your invoice number",
    fechaFactura: "Invoice date",
    importeFactura: "Invoice amount",
    tipoFactura: "Invoice type",
    codigoCuentaFactura: "Invoice account number",
    codigoRetencion: "Witholding code",
    baseRetencion: "Witholding base amount",
    porRetencion: "By witholding",
    importeRetención: "Witholding amount",
    baselva1: "Baselva 1",
    porlva1: "Porlva 1",
    cuotaIva1: "Cuota IVA 1",
    porRecargoEquivalencia1: "Por Recargo Equivalencia 1",
    recargoEquivalencia1: "Recargo Equivalencia 1",
    codigoTransaccion1: "Transaction code 1",
    descargarComoTxt: "Download as .txt",

    noHayAsientosContablesEnEsteTpvEnEsteRangoDeFecha: "No Accounting entry in this POS within this date range",
    cargandoAsientosContables: "Uploading Accounting entry",
    fechaDeAperturaDeCaja: "Cash desk closing (opening date)",
    fechaDeCierreDeCaja: "Cash desk closing (closing date)",
    descargarVentas: "Download sales",
    descargarGastos: "Download expenses",
    noHasCerradoEstaCaja: "No has cerrado esta caja",
    numeroDeCierres: "Número de cierres",
    introduzcaElUltimoNumeroDeAsientoContableQueTieneEnSAGE: "Introduzca el ultimo número de asiento contable que tiene en SAGE",
    porFavorRelleneElAsientoContable: "Por favor, rellene el asiento contable",
    descargar: "Descargar",
    elAsientoContableDebeSerUnNumero: "El asiento contable debe ser un número",
    elAsientoContableNoPuedeSerMayorA10Digitos: "El asiento contable no puede ser mayor a 10 dígitos",
    TengaEnCuentaQueUtilizaremosLosSiguientesNumerosAEsteParaCompletarLosDatos: "Tenga en cuenta que utilizaremos los siguientes números a este para completar los datos",
    noExistenVentasEsteDia: "No existen ventas este día",
    noExistenGastosEsteDia: "No existen gastos este día",
    enSage: "en SAGE",
    proyecto: "Proyecto",
    codigoEmpresaHelp: "Recuerda que el dato empresa se comparte entre todos los negocios de la misma empresa",
    cuentasDelTpvSeleccionado: "Cuentas del TPV seleccionado",
    nuevaCuenta: "Nueva cuenta",
    nombreDeCuenta: "Nombre de cuenta",
    codigoCuentaMinuscula: "Código cuenta",
    tipoDeCuenta: "Tipo de cuenta",
    noHayCuentasCreadasConElTpvSeleccionado: "No hay cuentas creadas con el TPV seleccionado",
    crearNuevaCuenta: "Crear nueva cuenta",
    codigoDeLaCuenta: "Código de la cuenta",
    codigoDeLaSubcuenta: "Código de la sub cuenta",
    configuracionCuentasIva: "Configuración cuentas IVA",
    configuracionCuentasEspeciales: "Configuración cuentas especiales",
    cuenta: "Cuenta",
    subcuenta: "Sub cuenta",
    editarCuenta: "Editar cuenta",
    tipo: "Tipo",
    sage200: "SAGE 200",
    losCamposNombreCodigoDeCuentaYCodigoDeSubcuentaDebenEstarRellenos: "Los campos nombre, código de cuenta y código de subcuenta deben estar rellenos",
    estaSeguroDeQueDeseaEliminarEstaCuenta: "¿Está seguro de que desea eliminar esta cuenta?",
    siBorrarCuenta: "Sí, borrar cuenta",
    cuentaEditadaCorrectamente: "Cuenta editada correctamente",
    cuentaCreadaCorrectamente: "Cuenta creada correctamente",
    configuracionSAGE: "Configuración Sage",
    sinCuentaAsociada: "Sin cuenta asociada",
    loSientoSuNegocioNoTieneContratadoSAGE: "Lo sentimos, su negocio no tiene contratado SAGE",
    paraMasInformacionContacteConComerciales: "Para más información contacte con comerciales",
    laLongitudMaximaDeLasSubCuentas: "La longitud máxima de la sub cuenta tiene que ser de 12 caracteres",

    // ----
    codigo: "Código",
    crearNuevoCodigoCuenta: "Crear nuevo código cuenta",
    editarNuevoCodigoCuenta: "Editar nuevo código cuenta",
    seleccioneUnaFormaDePagoParaElGasto: "Seleccione una forma de pago para el gasto",
    hasSeleccionadoAlbaranesConDiferentesFormasDePagoPorFavorSeleccioneUna: "Has seleccionado albaranes con diferentes formas de pago, por favor seleccione una",
    seleccioneUnaFormaDePago: "Seleccione una forma de pago",
    zonasActualizadasCorrectamente: "Zonas actualizadas correctamente",
    zonaCreadaCorrectamente: "Zona creada correctamente",
    zonaEditadaCorrectamente: "Zona editada correctamente",
    guardarCambios: "Guardar cambios",
    laZonaNoPuedeTenerElNombreEnBlanco: "La zona no puede tener el nombre en blanco",
    zonasDeReparto: "Zonas de reparto",
    editarZona: "Editar zona",
    color: "Color",
    costeDeReparto: "Coste de reparto",
    pedidoMinimo: "Pedido mínimo",
    crearNuevaZona: "Crear nueva zona",
    estasSeguroDeQueQuieresEliminarLaZona: "¿Estás seguro de que quieres eliminar la zona?",
    estaZonaDejaraDeEstarDisponibleInmediatamenteYNoSePodranHacerPedidos: "Esta zona dejará de estar disponible inmediatamente y no se harán pedidos desde la misma",
    siEliminarZona: "Sí, eliminar zona",
    zonaEliminadaCorrectamente: "Zona eliminada correctamente",
    ventasExportadas: "Ventas exportadas",
    gastosExportados: "Gastos exportados",
    todosLosCierresDeEsteDiaHanSidoExportados: "Todos los cierres de este día han sido exportados",
    faltanVentasPorExportarEsteDia: "Faltan ventas por exportar este día",
    todosLosGastosDeEsteDiaHanSidoExportados: "Todos los gastos de este día han sido exportados",
    faltanGastosPorExportarEsteDia: "Faltan gastos por exportar este día",

    //10-02-2021
    otros:'Otros',
    restriccionHorarios:'Restricción Horarios',
    restriccionHorariosDesc: "Restringir algunas franjas horarias(cerrado, lleno, no reparto...)",
    borrar: 'Borrar',
    restriccion: "Restricción", 
    nMaximoPedidos: "Nº Máximo de pedidos",
    cerrarFranja: "Cerrar franja",
    limitePedidos: "Límite Nº Pedidos",
    loSentimosSuNegocioNoTieneContratadoEsteModulo: "Lo sentimos, su negocio no tiene contratado este módulo",
    numeroPedidosPermitidos: "Número de pedidos permitidos",
    estaSeguroDeQueDeseaEliminarEstaRestriccion: "¿Está seguro de que desea eliminar esta restricción?",
    siBorrarRestriccion: "Sí, borrar restricción",
    loSentimosParaAccederAEsteModuloNecesitaActivarLaConfiguracion: "Lo sentimos, para acceder a este módulo necesita activar la configuración",
    costeSinIVA: "Coste sin IVA",
    /*this.$i18n.t("productos"))*/

    /*"$i18n.t('editar')*/

    //11.3.2021
    importeIVA: "Importe IVA",

    //17.3.2021
    pasarAPreparacion: "Pasar a preparación",
    pasarAPreparados: "Pasar a preparados",
    pasarAEnReparto: "Pasar a en reparto",
    finalizarPedido: "Finalizar pedido",
    //Tener en cuidado con los espacios, ya que son los espacios Braille
    domicilioActivado: "‏‏‎DOMICILIO⠀ACTIVADO",
    domicilioDesactivado: "DOMICILIO⠀DESACTIVADO",
    recogerActivado: "RECOGER⠀ACTIVADO",
    recogerDesactivado: "RECOGER⠀DESACTIVADO",
    //
    conDetalles: "con detalles",
    zonasRepartoActivadas: 'ACTIVADAS⠀',
    zonasRepartoDesactivadas: 'DESACTIVADAS⠀',
    siEliminarCategoria: "Sí, eliminar categoría",
    confirmaEliminarCategoria: "¿Está seguro de que quiere eliminar esta categoría?",
    pedidoPreparado: "Pedido preparado",
    configuracionParaLaImportacionExportacionDeDatosDeSage: "Configuración para la importación/exportación de datos de Sage",
    enEstaPantallaSeConfiguranLosCodigosDeLasCuentas: "En esta pantalla se configuran los códigos de las cuentas",
    formadosPor3Digitos: 'formados por 3 dígitos',
    estosSonNecesariosParaConfigurarLasCuentasContables: "Estos son necesarios para configurar las cuentas contables",
    alEditarUnCodigoRelacionadoConUnaCuentaContableYaExistente: "Al editar un código relacionado con una cuenta contable ya existente",
    todoCambioQueSeProduzcaSobreEsteAfectaraTambienALaPropiaCuenta: "todo cambio que se produzca sobre este afectará también a la propia cuenta",
    aContinuacionSeListaranLasCuentasDeTipo: "A continuación se listarán las cuentas de tipo",
    gastoMinuscula: "gasto",
    paraQue: "para que",
    asocieMinuscula: "asocie",
    ventaMinuscula: "venta",
    unaParaSuPosterior: "una para su posterior",
    relacionEnSage: "relación en SAGE",
    seleccioneUnaCuenta: "Seleccione una cuenta",
    aDomicilio: "A domicilio",
    aRecoger: "A recoger",
    tipoDeZona: "Tipo de zona",
    seleccioneUnTipo: "Seleccione un tipo",
    kilometrosDelArea: "Kms del área",
    codigoEmpleado: "Codigo empleado",
    exportarReservas: "Exportar reservas",
    importacionSinqro: "Importación Sinqro",
    configuracionParaLaImportacionDeDatosDeSinqro: "Configuración para la importación de datos de Sinqro",
    pasarelaDePago: "Pasarela de pago",
    importeSinDescuento: "Importe sin descuento",
    desactivarZona: "Desactivar zona",
    activa: "ACTIVA",
    inactiva: "INACTIVA",
    exportarPdfConMateriasPrimasAsociadas: "Exportar PDF con materias primas asociadas",
    exportarExcelConMateriasPrimasAsociadas: "Exportar Excel con materias primas asociadas",

    //Pedidos archivados 18/05/21
    informePedidosDetalle:"Desglose de pedidos",
    informePedidos:"Informe de pedidos",
    tipoPago:"Forma de pago",
    tipoPedido:"Tipo de pedido",
    domicilio:"Envio a domicilio",
    recoger:"Recogida en local",
    pagoLocal:"Pago en local",
    otro:"Otro",

    //25/05/2021
    configuracionTurnos: "Configuración turnos",

    //2021/05/20
    estasSeguroDeImportarTusProductosASinqro: "¿Desea importar sus productos a Sinqro?",
    esteProcesoPuedeTardarVariosMinutos: "Este proceso puede tardar varios minutos.",
    siImportarConSinqro: "Sí, importar a Sinqro",
    estasSeguroDeDarDeBajaElProducto: "¿Desea dar de baja el producto?",
    podraDarloDeAltaEnUnFuturo: "Podrá darlo de alta en un futuro",
    siDarDeBaja: "Sí, dar de baja",
    estasSeguroDeDarDeAltaElProducto: "¿Desea dar de alta el producto?",
    podraDarloDeBajaEnUnFuturo: "Podrá darlo de baja en un futuro.",
    siDarDeAlta: "Sí, dar de alta",
    laImportacionTardara: "Importando... este proceso puede tardar varios minutos",
    importacionFinalizada: "Importación completada con exito",
    completo: "Completado",
    vale: "Vale",
    importarSinqro: "Importar Sinqro",
    importandoProductos: "La importación se está llevando a cabo en estos momentos...",
    generandoCarta: "Este es el último paso... Estamos generando su carta.",
    procesoFin: "El proceso se ha completado con éxito",
    procesoCompletado: "Proceso completado",
    yaFaltaPoco: "Ya falta poco...",
    estamosEnEllo: "Estamos trabajando en la importacion. Por favor, no recargue el navegador. " ,
    finProgres: "El progreso terminó con exito.",
    textoInfo:"Esta columna muestra el precio de compra con descuento (el cual se calcula a partir del precio sin IVA)",
    correosEnviados: "Emails sent",
    correosEnviadosCorrectamente: "The emails were sent successfully.",
    errorAlEnviar: "Error sending",
    noSePudieronEnviarTodosLosCorreos: "Not all emails could be sent:",
    errorInesperadoEnvioCorreos: "An unexpected error occurred. Please try again later.",


    //07/06/2021
    valorRecuento: "Valor Recuento",
    
    //08/06/2021
    obligatorioEmail: "Obligatorio rellenar email",
    datosCliente : "Datos cliente",

    //11/06/2021
    recuerdeQueElHacerCobrosAvanzadosPuedeGenerarPequenosDescuadres:"Recuerde que el hacer cobros avanzados puede generar pequeños descuadres",
    yQue: "y que",
    losDescuentosDeLasVentasEstanAlCeroPorcientoDeIva:"los descuentos de las ventas estan al 0% de IVA",

    //16/06/2021
    totalValoresNegativos: "Total Valores Negativos",
    solamenteSeTieneEnCuentaValoresPositivos: "Solamente se tiene en cuenta valores positivos",
    totalValoresDiferencia: "Total Valores Diferencia",
    totalValoresDiferenciaDto: "Total Valores Diferecia Dto.",
    valorDiferencia: "Valor diferencia",
    valorDifereciaDto: "Valor diferencia dto.",
    precioDto: "Precio Dto.",

    //24/06/2021
    exportarMateriasPrimasAsociadasAEsteProducto: "Exportar materias primas asociadas a este producto",
    sinIVA: "Sin IVA",

    
    //MENÚS
    menus: "Menús",
    descripcionMenus: "Grupo de productos que se venden de forma conjunta",
    numeroDePlatos: "Número de platos que el cliente podrá elegir por cada plato:",
    platosTip1: "En esta pantalla se pueden crear los distintos platos que",
    platosTip2: "componen el menú para su posterior asignación con los productos.",
    productosPlatosTip: "En esta pantalla se pueden relacionar platos y productos para su posterior visualización en la carta.",
    plato: "Plato",
    platos: "Platos",
    primerPlato: "Primer plato",
    segundoPlato: "Segundo plato",
    tercerPlato: "Tercer plato",
    cuartoPlato: "Cuarto plato",
    quintoPlato: "Quinto plato",
    sextoPlato: "Sexto plato",
    seleccionaUnPlato: "Selecciona un plato",
    noPuedeDejarEnBlancoElNombreDeUnPlato: "No puede dejar en blanco el nombre de un plato",
    estaSeguroDeQueQuiereBorrarEstePlato: "¿Está seguro de que quiere borrar este plato?",
    seBorraranTodasLasAsociacionesDeProductosConElMismo: "Se borrarán todas las asociaciones de productos con el mismo",
    siEstoySeguro: "Sí, estoy seguro",
    estaSeguroDeQueQuiereDesvincularEsteProductoDelPlatoSeleccionado: "¿Está seguro de que quiere desvincular este producto del plato seleccionado?",
    dejaraDeFormarParteDelMenuDeFormaInstantanea: "Dejará de formar parte del menú de forma instantánea",
    noMostrarSuelto: "No mostrar suelto (sólo disponible en menús)",
    clonarMenu: "Clone menu",
    //29/07/2021
    totalPedidosDevueltos : "Nº de devoluciones",
    totalImportesDevueltos : "Total importe devuelto",

    //06/08/2021
    NoMostrarRecargasSaldo: "No mostrar recargas de saldo",
    //10/08/2021
    noMostrarDescuento: "No mostrar descuentos",
    //17/08/2021
    operarioApertura: "Operario apertura",
    aperturasPorOperarios: "Cuentas abiertas por operario",
    aperturasPorOperariosMinuscula: "cuentas abiertas por operario",
    aperturasOperarios : "Cuentas abiertas",
    productosPorAperturaDe: "Productos por apertura de",
    productosPorApertura:"Productos por apertura",
    facturasEmitidasMinuscula:"facturas emitidas",
    noMostrarDescuento: "No mostrar descuentos",

    //17/08/2021
    rangosDeMesas: "Rangos de mesas",
    agrupacionesDeMesasParaConsultarVentas: "Agrupaciones de mesas para consultar ventas",
    verUnInformeDeRangosDeMesas: "Ver informe de rangos de mesas",
    nuevoRangoMesa: "Nuevo rango mesa",
    mesaInicial: "Mesa inicial",
    mesaFinal: "Mesa final",
    noHayRangosDeMesasEnEsteTpv: "No hay rangos de mesas en este TPV",
    nombreRangoDeMesas: "Nombre rango de mesas",
    borrarRangoMesas: "Borrar rango de mesas",
    deseaEliminarEsteRangoDeMesas: "¿Desea eliminar este rango de mesas?",
    siBorrarEsteRangoDeMesas: "Sí, borrar este rango de mesas",
    ventasPorRangoDeMesas: "Ventas por rango de mesas",
    porRangoDeMesas: " por rango de mesas",
    numeroDeOperaciones: "Número de operaciones",
    precioMedioPorOperacion: "Precio medio por operación",
    propuestoParaCierre: "Propuesto para cierre",
    esteTicketHaSidoPropuestoParaSuCierreComaEstaUstedDeAcuerdo: "Este ticket ha sido propuesto para su cierre, ¿está usted de acuerdo?",
    siCerrarTicket: "Sí, cerrar ticket",
    propuestaDeCierreDeTicket: "Propuesta de cierre de ticket",
    noEstoyDeAcuerdo: "No estoy de acuerdo",
    ultimaRespuestaDelEquipoTecnico: "Última respuesta del equipo técnico",
    escribaAquiSuRespuesta: "Escriba aquí su respuesta",
    enviarRespuesta: "Enviar Respuesta",
    tienesTicketsPendientesDeCerrar: "Tienes tickets pendientes de cerrar",

    //26/08/2021
    exportarExcelDeTodosLosTickets: "Exportar Excel de todos los tickets",
    soloPuedesSacarInformesDeUnMesComoMaximo: "Solo puedes sacar informes de un mes como máximo",
    loSentimos: "Lo sentimos",
    noTienesNingunRangoDeMesasCreadoDeseasCrearUnRangoDeMesas: "No tienes ningun rango de mesas creado. ¿Deseas crear un rango de mesas?",
    siCrearUnRangoMesas: "Sí, crear un rango mesas",
    resActiva: "Activada",
    resInactiva: "Desactivada",

    // 07/08/2021
    usuarioSinAcceso: "Su usuario no tiene acceso a este modulo",

    //08/09/21
    pedidosHoras: "Pedidos por horas",
    graficaPedidosHoras: "Gráfica que muestra el número de pedidos agrupado por tramo horario en el dia de hoy",

    //20/09/21
    personalizacionCarta: "Personalizacion de la Carta Online",
    personalizacionCarta: "Personaliza tu carta ",
    personalizacion: "Personalización",
    conLasOpcionesQueTeOfrecemos: "con las opciones que te ofrecemos",
    opcionesConfiguracion: "Opciones de configuración",
    vistaPrevia: "Vista previa",
    imagenCargando: "Imagen de carga",

    //21/09/21
    diagnosis: "Diagnosis",
    diagnosticoProductos : "Diagnóstico de productos",
    comprobacionProducts: "Comprobación de productos", 
    diagnosticarProductos: "Diagnosticar productos",
    productosSinRelacionEnElTpv : "¡Todo correcto!",
    pulseElBoton:"Pulse el botón deseado",
    paraRealizarDiagnosis : "para realizar la diagnosis",
    productoRelacionadoConTpv : "Relacionado en el TPV con",
    noTieneRelacion:"No tiene relacion",
    hayProductosSinRelacion:"Hay productos que no estan relacionados en el TPV",
    
    //20/09/21
    destacadosTitulo: "Titulo destacado",
    nuevoTitulo: "Nuevo titulo",
    tituloActual: "Titulo actual",

    //22/09/21
    textos: "Textos",

    //21/09/21
    facturas: "Facturas",
    facturasMinusculas: "facturas",
    facturacionGeneral: "Facturación general",
    deTodasLasSeries: " de todas las series",

    //29/09/21
    permisoBusinessGestion: "Lo sentimos. No tienes permiso para utilizar esta herramienta en el negocio actual",
    permisoUsuarioGestion: "Lo sentimos. Este negocio no cuenta con este módulo activado.",
    traduccion: "Traducción",
    traduccionDe: "Traducción de",
    idioma: "Idioma",
    losDescuentosDeLasVentasEstanAlCeroDeIva: "Los descuentos de las ventas están al 0% de iva",
    recuerdeQueAlRealizarCobrosAvanzadosLosComensalesSeAsignaranALaFormaDePagoEfectivo: "Recuerde que al realizar cobros avanzados los comensales se asignaran a la forma de pago efectivo",
    mapasYZonas: "Mapas y zonas",
    idiomas: "Idiomas",
    permisoControlIdiomas: "Lo sentimos, este negocio no cuenta con el control de idiomas activado.",
    idiomasCartaTip1: "Para activar o desactivar un idioma puedes hacer clic en los interruptores.",
    idiomasCartaTip2: "Para ordenar los idiomas en la carta, puedes utilizar el campo orden.",
    idiomasCartaTip3: "Los idiomas con un orden menor aparecerán primero.",
    excluirPrecioMedioMenu: "Excluir del precio medio los productos vendidos en menús",

    //19/06/2023
    conIvaDesglosado: "IVA itemized",

    //10/01/24
    tolTipLogo: "Add your restaurant's logo to appear on the home screen and your QR code. The recommended size is 90 x 90 px.",
    tolTipFondo: "Add a high-quality photo to appear as a cover on your QR menu. The recommended size is 1280 x 1024 px.",
    tolTipImagenProducto: "Add a high-quality image to visually showcase your product attractively. For menu products, create a new one with an ideal resolution of 500 x 500 pixels or 12 cm x 12 cm.",
    tolTipNombreMostrado: "Enter the name you want to display for your business here.",
    tolTipEmail: "Provide a contact email for your customers.",
    tolTipTelefono: "Provide a contact phone number.",
    tolTipDescripcion: "Briefly describe your restaurant: the concept and experience you offer.",
    tolTipDireccion: "Provide the address of the restaurant that corresponds to this menu.",
    tolTipPresentacion: "Write a suitable call to action to encourage your customers to open your card on the home screen.",
    tolTipHorario: "Present your schedule or share additional information (holidays, out of service...).",
    tolTipMostrarCategoriaDeBaja: "If you check the box, the categories you have marked as inactive will be displayed but will not appear in your menu.",
    tolTipMostrarProductoDeBaja: "If you check the box, the products you have marked as inactive will be displayed but will not appear in your menu.",
    tolTipTraducirCategoria: "Translate the category titles into the language you prefer.",
    tolTipConvertirCategoriaPadre: "Convert into a parent category.",
    tolTipOrdenCategorias: "If you want this category to appear first, the number should be '1', and so on accordingly to the order.",
    tolTipBajaCategoria: "By activating this option, the selected category will no longer appear in your digital menu when customers access it. Deactivating a category means that all products included under that specific category will also become invisible to your customers.",
    tolTipVerQr: "Access and download the QR code for your menu.",
    tolTipDisponibleProducto: "Mark the availability of the product: Indicate whether a product is available or not on your menu.",
    tolTipIdiomaProducto: "Choose the language in which you want the product to be presented.",
    tolTipOrdenProducto: "Choose the order in which you want the product to appear within the selected category.",
    tolTipProductoDestacado: "If you select this option, the product will appear in a featured section at the beginning of the menu. Highlight special products or promotions.",
    tolTipBaja: "This product will not be displayed on your menu (if activated).",
    tolTipDisponible: "Activate the button if the product is available for sale. Deactivate if the product is 'Out of Stock' (when there are no stocks).",
    tolTipImagenCarga: "Image that will be displayed during the brief seconds when your menu is loading.",
    tolTipTituloDestacado: "Here you can define the text that will name the section of featured products. Example: 'Chef's Recommendations', 'Our Top Sellers,' or 'Can't Miss Items'.",
    tolTipIdiomaMateriaPrima: "Choose the language in which you also want the raw material to be presented",
    guiaUsuario: "User Guide",

    //14/02/24
    pedidosPorRepartidores: "Orders by delivery men",
    nombreRepartidor: "Delivery man name",
    cantidadDePedidos: "Order quantity",
    
    //18/10/24
    listadoTicketRepartidor: "Tickets by delivery person",

    
    //12/03/24
    basesFree : "Bases extras gratis",
    extrasFree : "Bases / Extras gratis",
    tooltipBaseExtra: "If the base is activated, it doesn't add extra for free. If the extra is activated, it won't count as free when added.",

    exportar: "Export",
    codigoBarras: "Barcode",

    //WALLET
    passbooks: "Passbooks",
    sharePassbooks: "Share wallets",
    copyToClipboard: "Copy to clipboard",
    shareViaEmail: "Send via email",
    shareViaWhatsapp: "Send via WhatsApp",
    copied: 'Copied to clipboard',
    selectBusinessForWallet: 'Choose the business for which you want to send the Wallets',
    sendMethod: 'Send method',
    share: "Send",
    sendAndSaveButton: 'Yes, send and save',
    sendAndNoSaveButton: 'No, send and do not save',
    titleSaveInfoModalText: 'The customer information has changed. Do you want to save this information?',
    verifyNumberText: 'Verify the phone number',
    verifyEmailText: 'Verify the email',
    selectOption: 'Select an option',
    clipboardCopied: 'Copied to clipboard',
    clipboardFailedToCopy: 'The clipboard API is not available in this browser.',
    enviarWallet: 'Send Wallet',
    confirmacionEnvioWallet: 'Wallet Sending Confirmation',
    confirmacionTextoEnviarWallet: 'Are you sure you want to send the wallet to all customers?',
    mensajeConfirmacion: "This action cannot be undone and will only be sent to customers whose email is added and who have a Barcode.",
    enviar: "Send",
    noHayCorreosElectronicos: "There are no emails.",
    ningunClienteConCorreoElectronico: "No customer with a configured email was found.",
    clientHasNoBarcode: "The client does not have a barcode set.",

    exportarCarta: "Export Menu",
    exportarSimplifiedExcel: "Export as Simplified Excel",

    //GESTIÓN DE IMPUESTOS
    taxes: "Taxes",
    tax: "Tax",
    gestionImpuestos: "Tax Management",
    administracionTiposTasas: "Administration",
    administracionTiposTasasImpositivas: " of types and tax rates",
    agregarImpuesto: "Add Tax",
    taxRate: "Applied Tax",
    taxDescription: "Description",
    taxType: "Tax Type",
    taxBoldType: "taxes",
    impuestoAplicadoEsCero: "The Applied Tax cannot be less than ",
    impuestoYaCreado: "This tax already exists and cannot be created again",

    //IMPORTAR CLIENTES 
    previewClientData: "Preview",
    editarCliente: "Edit client",
    importarData: "Import data",
    importandoDatos: "Importing data",
    importacionRealizada: "Import completed",
    datosImportados: "The data was successfully imported",
    confirmarImportacion: "Confirm import",
    seguroContinuarImportacion: "Are you sure you want to proceed? This action is irreversible",

    //18/11/24-Update-Logo
    inserteImagen: "Insert Image",
    seleccioneArchivoImagen: "Select an image file",
    archivoDemasiadoGrande: "The file is too large. The maximum allowed size is 5MB.",
    dimensionesExcedenLimite: " The image dimensions exceed the allowed limit (2000x2000px).",
    mensajeconfirmacion: "You are about to replace the existing image. Do you want to save?",
    botonGuardar: "Save",
    botonCancelar: "Cancel",
    Guardado: "Saved",
    guardarOvisualizarLogo: "View or save logo",
    seleccionLogo: "Click to select a Logo",
    volver: "Back",
    noHayImagen: "No image saved.",
    informacion: "Information: ",
    tamaño: "Size: ",
    dimensiones: "Dimensions: ",
    restriccionesLogo: "Logo restrictions:",
    tamañoMaximo: "Max size: ",
    dimensionesMaximas: "Max dimensions: ",

    //13/12/24
    //ProductosNoRelacionados.NEWs
    mensajeAviso: "Are you sure you want to automatically generate the PLUs? This process will generate a code for each product and rate that are not configured, and it will be saved automatically.",
    mensajeAvisoSubProducto: "Are you sure you want to automatically generate the PLUs? This process will generate a code for each raw material that is not configured, and it will be saved automatically.",
    aviso: "Warning!",
    generarPlu: "Automatically Generate PLUs",
    botonAceptar: "Accept",
    PLUsGenerados: "PLUs generated successfully!",
    errorGenerandoPLUs: "Error generating the PLUs",

    //ListadomateriaPrima-Proveedor.
    //14/01/25
    verListado: "Raw Materials List",
    listadoMateriaPrimaProveedor: "Raw Materials Supplier List",
    noTiene: "Does not have ",
    esteProveedor: " this supplier",
    proveedor: "Supplier Name:   ",

    precioAcordado: "Agreed price with supplier",
    porcentajeAcordado: "Agreed percentage",
    FiltrarPorEtiqueta: "Filter by tag:",
    precioAcordadoGuardadoCorrectamente: "Agreed price saved successfully!",
    fijarprecio: "Set price ",
    preciofijado: "(Set the raw material price)",
    mensajePrecioFijado: "The raw material price is ",
    explicacionFijarPrecio: "By activating it, the raw material price and discount percentage will be fixed. When creating a new expense, neither the price nor the discount will be modified.",
    porcentajeAcordado: "Alert percentage",
    porcentajeAcoradoGuardado: "AAgreed percentage. Saved successfully!",
    SubproductoIncrementado: "Raw material increased",
    LosSubproductosSeHanIncrementado : "The expense could not be verified, as an increase in the price of the following raw materials above the agreed percentage with the supplier was detected",
    errorverificar: "Error verifying",
    MateriaPrimasIncremento:"A 5% increase has been recorded in the following raw materials: ",
    ConfirmacionGuardar: "Do you want to save?",
    Elsubproducto: " The raw material ",
    MensajeErrorVerificarTodo: "Not all expenses can be verified as the following expenses show an increase in raw material price above the agreed percentage with the supplier",
    explicacionPorcentajeAcordado: "This is the agreed percentage with the supplier to control the raw material price when making an expense.",
    
    //21/01/2025
    nosmudamos: "We're moving!",
    noscambiamosaselfi: "Your business has taken a big step: we are now part of the Selfibar family. From now on, all configurations and management can be done directly in Selfibar",
    irASelfibar: "Go to Selfibar",
    barcodeUnico: "Unique barcode",
    barcodeNecesarioSeActualizara: "The barcode is required for this action and will be updated for this client when sending or copying to the clipboard.",    
    generarBusinessHash: "Generate URL for workers",
    enlaceFicharTurnosOperario: "Access for clocking in and checking shifts",
    enlaceFicharTurnosOperarioDescripcion: "Business workers can log in with the same credentials as the POS to record their shift start and end times, as well as review the last 14 shifts along with their durations.",
    
};


// WEBPACK FOOTER //
// ./src/language/english.js